export const en = {
  home: 'Home',
  dashboard: 'Dashboard',
  judicialTableegh: 'Judicial tableegh',
  eServices: 'E-services',
  retreat: 'Retreat',
  delete: 'Delete',
  cancel: 'cancel',
  next: 'next',
  previous: 'previous',
  useTheService: 'Use the service',
  cancelRequestConfirmation: 'Do you want to cancel the request ?',
  cancelRequestConfirmationText: 'Cancel request confirmation Text',
  rejectRequest: 'reject request',
  unAvailable: 'Un available',
  edit: 'Edit',
  verificationServices: 'Verification services',
  hijriSuffix: 'H',
  gregorianSuffix: 'M',
  morningTimeFullSuffix: 'Morning',
  eveningTimeFullSuffix: 'Evening',

  serverErrors: {
    NOT_FOUND: 'We cannot serve you at the moment. Please try again later',
    SERVER_ERROR: 'Something went wrong, please try again later',
    BIRTH_DATE_AND_SOCIAL_ID: 'Social id or birth date is not correct',
    RequestShouldBeValidToCancel: 'Something went wrong, invalid request',
  },

  validations: {
    onlyNumbers: 'Please enter numbers only',
    minNumbersLength: 'Min numbers length is {length}',
    fieldIsRequired: 'Field is required',
    shouldContainNumbers: 'Should contain {numbers} number',
    minNumberValue: 'Enter number greater than {minValue}',
  },
};
